module.exports = __webpack_public_path__ + "img/lg_ring_y_c_0_null@3x.44d75023.png";